import _ from 'lodash'

class Canvas {
  constructor ( setting ) {

    if(!window.HTMLCanvasElement){
      console.log("can't load canvas element")
      return;
    }
  
    // property
    var self = this;
    this.mouseX = 0;
    this.mouseY = 0;
    // this.name = setting.name || null;
    this.container = setting.container ? document.getElementById(setting.container) : document.body;
  
    // var testAlterimage = true;
    if(!window.HTMLCanvasElement){
      this.image = document.createElement("img");
      this.image.setAttribute('src', setting.alterImage);
      this.container.appendChild(this.image);
      return;
    }else{
      this.canvas = document.createElement("canvas");
      this.container.appendChild(this.canvas);
      this.canvas.setAttribute('id', setting.id ? setting.id : setting.container + '_canvas');
    }
  
  
    this.width = setting.width === 'auto' ? this.container.clientWidth : setting.width;
    this.height = setting.height === 'auto' ? this.container.clientHeight : setting.height;
    Canvas.prototype.resize(this, this.container, setting.width === 'auto', setting.height === 'auto');
  
    this.mouseX = this.width/ 2;
    this.mouseY = this.height/ 2;
  
    this.canvas.width = this.width;
    this.canvas.height = this.height;
  
    // EVENT ------------------------------------------------
    Canvas.prototype.mousemove(this);
    // Canvas.prototype.fullscreen(this);
    return this;
  }

  mousemove ( self ) {
    self.canvas.addEventListener('mousemove', function(e){
      self.mouseX = e.offsetX
      self.mouseY = e.offsetY
    })
  }
  // getContext ( ctx ) {
  //   this.context = this.canvas.getContext(ctx)
  //   return this.context
  // }
  zoom () {
	  return this.width  ? 1.0 : 1.0
  }
  resize ( self, container, width, height ) {
    window.addEventListener('resize', _.throttle( function () { 
      if(width){
        self.width = container.clientWidth
        // self.zoom = self.width  ? 1.0 : 1.0
        self.canvas.width = self.width
      }
      if(height){
        self.height = container.clientHeight
        self.canvas.height = self.height
      }
      if(self.gl){
        self.gl.viewport(0, 0, self.width, self.height)
      }
    }))
  }
  fullscreen ( self ) {
    self.canvas.addEventListener('click', function(e){
      self.canvas.webkitRequestFullscreen() //HTML5 Fullscreen API仕様
    })
  }
  getWebGL () {
    this.gl = this.canvas.getContext('webgl', { premultipliedAlpha: true }) || this.canvas.getContext('experimental-webgl')
    // console.log(this.gl)
    return this.gl
  }
}

export default Canvas
